"use client";

import React from "react";
import { Heart, ShieldCheck, Sparkles } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const promiseValues = [{
  title: "Dignity",
  description: "We honor the life experiences of each resident by providing compassionate, personalized care that helps every individual feel valued, respected, and understood.",
  icon: Heart,
  borderColor: "border-t-primary",
  iconColor: "text-primary",
  bgColor: "bg-primary/10"
}, {
  title: "Respect",
  description: "In our small home of up to five residents, privacy, personal choice, and independence are always respected while providing the support each resident needs.",
  icon: ShieldCheck,
  borderColor: "border-t-secondary",
  iconColor: "text-secondary",
  bgColor: "bg-secondary/10"
}, {
  title: "Attention",
  description: "Our close-knit, family-style environment allows caregivers to focus on each resident, providing the attentive care that larger facilities often cannot offer.",
  icon: Sparkles,
  borderColor: "border-t-chart-4",
  iconColor: "text-chart-4",
  bgColor: "bg-chart-4/10"
}];
export default function OurPromise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="our-promise" className="dark bg-background text-foreground py-24 px-6 md:px-12 lg:px-24 overflow-hidden">
      <div ref={ref} className={`mx-auto max-w-7xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center mb-16 max-w-2xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-serif font-bold tracking-tight mb-4 text-foreground">A Small, Loving Assisted Living Home for Your Family</h2>
          <p className="text-muted-foreground text-lg leading-relaxed">
            Family First Senior Care is a small residential assisted living home in Silver Spring, Maryland, serving up to 5 residents with personalized care and a warm, family-like atmosphere.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {promiseValues.map((value, i) => {
          const Icon = value.icon;
          return <div data-index={i} key={i} className="h-full">
                <Card className={`h-full border-t-4 ${value.borderColor} bg-card/50 backdrop-blur-sm border-x-border/50 border-b-border/50 shadow-lg hover:shadow-xl transition-shadow duration-300`}>
                  <CardHeader className="pb-4">
                    <div className={`w-12 h-12 rounded-2xl ${value.bgColor} flex items-center justify-center mb-4`}>
                      <Icon className={`w-6 h-6 ${value.iconColor}`} />
                    </div>
                    <CardTitle className="text-2xl font-serif text-card-foreground">
                      {value.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-base text-muted-foreground leading-relaxed">
                      {value.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}